// extracted by mini-css-extract-plugin
export var coverSlide = "styles-module--cover-slide--dxwTU";
export var coverPseudobutton = "styles-module--cover-pseudobutton--JPhBI";
export var coverImg = "styles-module--cover-img--rbYPI";
export var pbCorrection = "styles-module--pb-correction--uUHuB";
export var topLeftWrapper = "styles-module--top-left-wrapper--c7rXI";
export var lastCorner = "styles-module--last-corner--5VgV7";